var map = {
  "./DepartmentDropdown.js": [
    "96089",
    "5938"
  ],
  "./CDSMeeting.js": [
    "44803",
    "1753",
    "2028",
    "2969",
    "3325",
    "5457",
    "4783",
    "4855",
    "5822",
    "6726",
    "5180",
    "48"
  ],
  "./CERNFields.js": [
    "80439",
    "7036"
  ],
  "./CERNPublication.js": [
    "97186",
    "3599"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 34222;
module.exports = __rspack_async_context;
